import { SECTION_KEYS } from '@/features/ap_payees/components/PayeeDetailDrawer/types';
import {
  createContext,
  FC,
  ReactNode,
  useCallback,
  useContext,
  useState,
} from 'react';

export const usePayeeDetailDrawer = () => {
  const context = useContext(PayeeDetailDrawerContext);
  if (!context) {
    throw new Error(
      'usePayeeDetailDrawer must be used within PayeeDetailDrawerProvider'
    );
  }
  return context;
};

type PayeeDetailDrawerContextValue = {
  refetch: () => void;
  isEditingSection: SECTION_KEYS;
  setIsEditingSection: (section: SECTION_KEYS) => void;
  onClose?: () => void;
};

export const PayeeDetailDrawerContext =
  createContext<PayeeDetailDrawerContextValue | null>(null);

export type ProviderProps = {
  children: ReactNode;
  refetch: () => void;
  onClose?: () => void;
};

export const PayeeDetailDrawerProvider: FC<ProviderProps> = ({
  children,
  refetch,
  onClose,
}) => {
  const [isEditingSection, setIsEditingSection] = useState<SECTION_KEYS>(
    SECTION_KEYS.NULL
  );

  const handleSetIsEditingSection = useCallback((section: SECTION_KEYS) => {
    setIsEditingSection(section);
  }, []);

  const value: PayeeDetailDrawerContextValue = {
    refetch,
    isEditingSection,
    setIsEditingSection: handleSetIsEditingSection,
    onClose,
  };

  return (
    <PayeeDetailDrawerContext.Provider value={value}>
      {children}
    </PayeeDetailDrawerContext.Provider>
  );
};

PayeeDetailDrawerProvider.displayName = 'PayeeDetailDrawerProvider';
